export const APP_VERSION = '0.1.0';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const ADMIN = 'ADMIN';
export const OPERATOR = 'OPERATOR';
export const MANAGER = 'MANAGER';

export const WATCH = 'GUARDIA';
export const NORMAL = 'NORMAL';

export const OPEN = 'OPEN';
export const PLANNED = 'PLANNED';
export const CANCELED = 'CANCELED';
export const COMPLETED = 'COMPLETED';
export const DELAYED = 'DELAYED';
export const WORKING = 'WORKING';

export const CURRENCY_SYMBOLS = {
  EUR: { symbol: "€", before: false },
  USD: { symbol: "$", before: true },
  GBP: { symbol: "£", before: true },
  AUD: { symbol: "$", before: true}
};